<template>
    <div class="orderInfo m-b-20">
        <titles name="订单信息"></titles>
        <ul class="information">
            <li>
                <p>订单号：<span class="infoColor">{{item.orderNumber}}</span></p>
            </li>
            <li>
                <p>姓名：<span class="infoColor">{{item.customerName}}</span></p>
            </li>            
            <li>
                <p>联系电话：<span class="infoColor">{{item.customerPhone}}</span></p>
            </li>            
            <li>
                <p>订单地址：<span class="infoColor">{{item.orderAddress}}</span></p>
            </li>            
            <li>
                <p>导购：<span class="infoColor">{{item.salesmanName}} | {{item.salesmanPhone}}</span></p>
            </li>            
            <li>
                <p>设计师：<span class="infoColor">{{item.surveyorName}} | {{item.surveyorPhone}}</span></p>
            </li>
        </ul>
    </div>
</template>
<script>
import titles from '@/components/titiles.vue';
export default {
    components:{
        titles,
    },
    props: {
        item: {
        type: Object,
        default: {}
        },
    },
    data(){
        return {
            
        }
    }
}
</script>
<style lang="scss" scoped>
.orderInfo{
    background: $ffff;
    padding-bottom: 1px; 
    .information{
        margin-left: 56px;
        font-size:24px;
        color:$color-51;
        padding-top:25px;
        li{
            margin-bottom: 28px;
            position: relative;
            .infoColor{
                color: $color-153;
                position: absolute;
                left: 140px;
            }
        }

    }
}
</style>
